import { table } from './table';

export const rates = {
  namespaced: true,
  modules: {
    table
  }
};
